<template>
  <section class="recommend">
    <h2 class="recommend__balloon">
      <img
        :src="require(`@/assets/images/pool-balloon.svg`)"
        width="231"
        height="81.5"
        alt="きみにおすすめのプールはここだ！"
      >
    </h2>
    <div class="recommend__content">
      <div
        v-for="item in recommends"
        :key="item.id"
        class="recommend__item"
      >
        <result-recommend-item
          :item="item"
        />
      </div>
    </div>
  </section>
</template>

<script>
import ResultRecommendItem from '@/components/parts/ResultRecommendItem.vue';

export default {
  name: 'ResultRecommend',
  components: {
    ResultRecommendItem
  },
  props: {
    recommends: {
      type: Array,
      default: () => []
    },
  }
}
</script>

<style lang="scss" scoped>
@use "@/assets/scss/foundation/config/colors";
@use "@/assets/scss/foundation/config/mediaquery";
@use "@/assets/scss/foundation/mixin";

.recommend__balloon img {
  @include mediaquery.minMediaMajor {
    width: 320px;
    height: auto;
  }
}

.recommend__content {
  display: grid;
  margin-top: 35px;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  @include mediaquery.minMediaMajor {
    margin-top: 50px;
    gap: 40px 48px;
    grid-template-columns: repeat(3, 1fr);
  }
  @include mediaquery.minMediaLarge {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>